import React, { Component } from 'react';
import is from 'is_js';

import { ConfirmDialog } from 'omni-common-ui';
import PropTypes from 'prop-types';

const MSG = 'Are you sure you want to delete this?';

export class DeleteWarning extends Component {
  componentWillReceiveProps(nextProps) {
    const { isOpen, isDeleting, onDeleted } = this.props;
    if (isOpen && isDeleting && ! nextProps.isDeleting) {
      onDeleted && onDeleted();
    }
  }

  render() {
    const props = this.props;
    return <ConfirmDialog isOpen={is.function(props.isOpen) ?
          props.isOpen() : !! props.isOpen}
        isLoading={is.function(props.isDeleting) ?
          props.isDeleting() : !! props.isDeleting}
        primaryButtonContent="Cancel"
        secondaryButtonContent="Delete"
        onPrimaryClick={() =>
          props.onDiscardClicked && props.onDiscardClicked()}
        onSecondaryClick={() =>
          props.onDeleteClicked && props.onDeleteClicked()}
        onRequestClose={() =>
          props.onCloseClicked && props.onCloseClicked()}>
      <span>
        { is.undefined(props.warningMessage) ? MSG : props.warningMessage}
      </span>
    </ConfirmDialog>;
  }
}

DeleteWarning.propTypes = {
  isOpen: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func,
  ]),
  isDeleting: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func,
  ]),
  onDiscardClicked: PropTypes.func,
  onCloseClicked: PropTypes.func,
  onDeleteClicked: PropTypes.func,
  onDeleted: PropTypes.func,
  warningMessage: PropTypes.string,
};

export default DeleteWarning;



// WEBPACK FOOTER //
// ./components/DeleteWarning/index.jsx